import UserService from '../Services/userService';

export default class CreateTpClientPaymentItem {
  constructor() {
    const officeId = UserService.GetOfficeIdOfLoggedInUser();
    this.ClientId = '';
    this.Type = '';
    this.EntryDateUtc = new Date();
    this.PaymentInstrumentDateUtc = new Date();
    this.CurrencyId = '';
    this.CheckNumber = '';
    this.AmountPaid = '';
    this.ReceivingOfficeId = officeId;
    this.Notes = '';

    this.staticClient = 0;
  }
}
